// extracted by mini-css-extract-plugin
export default {"TableContainer":"AJvEbFMcrOY_ZJ5PUC1D","Table":"yIgECYWjJiHVEqORIU9A","Cell":"XrBOdV6jOtTgaNpePm8S","Td":"ZRhQ6yDqRHhaPrv_4S_k","Th":"pMAsl5Q2x_2qxTOuV8lN"};